import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { queryClient } from "../../../store";
import { closeModal } from "../../modal/modal";
import Cookies from "js-cookie";

export type PostExtraTokenShowLoadAction = {
  type: string;
  payload: {
    tokens_num: number | string;
    currency_id: number | string;
    use_wallet?: boolean;
    router?: any;
  };
};

export type PostExtraTokenShowData = {
  data: {
    redirect_link: string;
    message: string;
  };
};

export const PostExtraTokenShow = new ReduxFetchState<
  PostExtraTokenShowData | null,
  {
    tokens_num: number | string;
    currency_id: number | string;
    use_wallet?: boolean;
    router?: any;
  },
  any
>("postExtraTokenShow");

export function* watchPostExtraTokenShow(action: PostExtraTokenShowLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();
    const { tokens_num, currency_id, use_wallet } = action.payload;

    const data: PostExtraTokenShowData = yield axios({
      url: `/api/v1/ai/subscription/extra-token/buy`,
      method: "POST",
      data: {
        tokens_num,
        currency_id,
        use_wallet,
        callback_url: window.location.href,
      },
      headers: { lang },
    });

    yield put(PostExtraTokenShow.actions.loadSuccess({ data: data.data }));
    queryClient.removeQueries({ queryKey: ["checkLogin", lang] });
    Cookies.remove("checkLogin", { domain: ".lamtakam.com" });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    if (data.data.redirect_link) {
      window.open(data.data.redirect_link, "_self");
    } else {
      yield put(closeModal());
      alert({ message: data?.data?.message, type: "success" });
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(PostExtraTokenShow.actions.loadFailure(e.message));
  }
}

export function* postExtraTokenShowSagas() {
  yield takeEvery(PostExtraTokenShow.actionTypes.load, watchPostExtraTokenShow);
}

export function usePostExtraTokenShow() {
  const { loading, data, ...postExtraTokenShowState } = useAppSelector(
    (state) => state.postExtraTokenShow,
  );
  const dispatch = useAppDispatch();

  const dispatchPostExtraTokenShow = useCallback(
    (data: {
      tokens_num: number | string;
      currency_id: number | string;
      use_wallet?: boolean;
      router?: any;
    }) => {
      dispatch(PostExtraTokenShow.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...postExtraTokenShowState,
    dispatchPostExtraTokenShow,
    postExtraTokenShowLoading: loading,
    postExtraTokenShowData: data,
  };
}

export const {
  actionTypes: postExtraTokenShowActionsTypes,
  actions: postExtraTokenShowActions,
  reducer: postExtraTokenShowReducer,
} = PostExtraTokenShow;
